import { DatesHelpers } from "@core/helpers";
import { i18n } from "@core/plugins/i18n";
import { ReviewModel, IReview } from "./review.model";

export class ReviewExtraModel extends ReviewModel {
  getExtraId() {
    return this[IReview.extraId];
  }

  getExtraFirstname() {
    return this[IReview.firstname];
  }

  getExtraLastname() {
    return this[IReview.lastname];
  }

  getPicture() {
    return this[IReview.photo];
  }

  getDatesMoment() {
    return {
      start: DatesHelpers.getDayjs(this[IReview.start]),
      end: DatesHelpers.getDayjs(this[IReview.end]),
    };
  }

  isOneDay() {
    const dates = this.getDatesMoment();
    return dates.start.isSame(dates.end, "day");
  }

  getDatesDisplay() {
    const dates = this.getDatesMoment();
    const startDate = dates.start.format("ddd DD MMM");
    const endDate = dates.end.format("ddd DD MMM");
    if (this.isOneDay()) {
      return i18n.global.t("CORE.MODELS.REVIEW.@DATES_ONE_DAY", { startDate });
    }

    return i18n.global.t("CORE.MODELS.REVIEW.@DATES_START_END", { startDate, endDate });
  }
}
